import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import CreateGajiKaryawan from "../../componen/gajiKaryawan/admin/CreateGajiKaryawan";

export const CreateGajiKaryawanPages = () => {
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate("/", { replace: true });
  }, [isError, navigate]);

  useEffect(() => {
    if (user && user.role !== "admin" && user.role !== "superadmin") {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  return (
    <Layout>
      <CreateGajiKaryawan />
    </Layout>
  );
};
